import React from 'react';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import { GlobalViewTaxForm } from './global-viewtaxform';
import { ViewTaxFormPropTypes } from '../../shapes';

export const UGTaxViewTaxForm = props => (
  <GlobalViewTaxForm
    {...props}
    countryCode={Constants.CountryCode.UG}
    showTaxCert={false}
  />
);

UGTaxViewTaxForm.propTypes = ViewTaxFormPropTypes;
